__turbopack_context__.v({
  "card": "Card-module-scss-module__DHQCkG__card",
  "descritption": "Card-module-scss-module__DHQCkG__descritption",
});
